import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-dark text-white py-5">
      <Container>
        <Row className="mb-4">
          <Col lg={4} className="mb-4 mb-lg-0">
            <h4 className="fw-bold mb-3">Aditya Joshi</h4>
            <p className="text-white-50">
              Master-level software engineer specializing in backend development,
              system design, and building scalable solutions.
            </p>
          </Col>
          <Col lg={4} className="mb-4 mb-lg-0">
            <h5 className="fw-bold mb-3">Quick Links</h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                <a href="#home" className="text-white-50 text-decoration-none">
                  Home
                </a>
              </li>
              <li className="mb-2">
                <a href="#about" className="text-white-50 text-decoration-none">
                  About
                </a>
              </li>
              <li className="mb-2">
                <a href="#services" className="text-white-50 text-decoration-none">
                  Services
                </a>
              </li>
              <li className="mb-2">
                <a href="#contact" className="text-white-50 text-decoration-none">
                  Contact
                </a>
              </li>
            </ul>
          </Col>
          <Col lg={4}>
            <h5 className="fw-bold mb-3">Connect</h5>
            <div className="d-flex gap-3">
              <a
                href="https://github.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white-50"
                style={{ fontSize: '1.5rem' }}
              >
                <i className="fab fa-github"></i>
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white-50"
                style={{ fontSize: '1.5rem' }}
              >
                <i className="fab fa-linkedin"></i>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white-50"
                style={{ fontSize: '1.5rem' }}
              >
                <i className="fab fa-twitter"></i>
              </a>
              <a
                href="mailto:meadityabjoshi@gmail.com"
                className="text-white-50"
                style={{ fontSize: '1.5rem' }}
              >
                <i className="fas fa-envelope"></i>
              </a>
            </div>
          </Col>
        </Row>
        <Row className="pt-4 border-top border-secondary">
          <Col className="text-center">
            <p className="mb-0 text-white-50">
              &copy; {currentYear} Aditya Joshi. All rights reserved.
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;